import React from 'react';
import { DSInput, DSSelect, DSSheet } from '../design-system/primitives';
import './PinGolfHoleList.css';

// The fields that make up one PinGolf hole, in a sheet. Extracted from PinGolfHoleList so
// that editing a hole and adding one are the same form: the add flow used to be a bare
// machine picker, which meant a hole added on a night arrived with whatever the machine
// record happened to say and no way to see or change it in the same breath.
//
// hole: { machineId, name, targetScore, maxBalls }
// machines: optional [{ id, name }] - when passed the machine is a select, otherwise it is
//   shown as a fixed read-only pair (a hole already tied to a live event cannot move).
// onChange(field, value): called for 'machineId' | 'targetScore' | 'maxBalls'.
// footer: the sheet's action buttons, so each caller owns its own verbs.
function PinGolfHoleSheet({ title, hole, machines, onChange, onClose, footer, disabled = false }) {
  return (
    <DSSheet title={title} onClose={onClose} footer={footer}>
      {machines ? (
        <DSSelect
          label="Machine"
          value={hole.machineId ?? ''}
          onChange={(e) => onChange('machineId', e.target.value)}
          disabled={disabled}
        >
          <option value="">Select a machine...</option>
          {machines.map((machine) => (
            <option key={machine.id} value={machine.id}>{machine.name}</option>
          ))}
        </DSSelect>
      ) : (
        <div className="pgh-sheet-fixed-machine">
          <span className="pgh-sheet-fixed-label">Machine</span>
          <span className="pgh-sheet-fixed-value">{hole.name}</span>
        </div>
      )}

      <DSInput
        label="Target score"
        type="number"
        placeholder="Target"
        value={hole.targetScore ?? ''}
        onChange={(e) => onChange('targetScore', e.target.value)}
        disabled={disabled}
        helpText="What a player has to beat on this machine. A hole with no target cannot be scored."
      />
      <DSInput
        label="Max balls"
        type="number"
        placeholder="Balls"
        value={hole.maxBalls ?? ''}
        onChange={(e) => onChange('maxBalls', e.target.value)}
        disabled={disabled}
        helpText="How many balls a player gets to reach the target. Usually 3."
      />
    </DSSheet>
  );
}

export default PinGolfHoleSheet;
